<div class="customPanel">

  <!-- TITLE SECTION -->
  <!-- HOME -->
  <h1 *ngIf="!csvFilePage && !csvFilePageDownload && !devicesToInsertPage" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get("options.title")}}
  </h1>

  <!-- TITLE SECTION -->
  <!-- UPLOAD CSV -->
  <h1 *ngIf="csvFilePage && !devicesToInsertPage" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get("uploadCSV.title")}}
  </h1>

  <h1 *ngIf="csvFilePageDownload && !devicesToInsertPage" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get("uploadCSV.downloadCSV")}}
  </h1>

  <!-- TITLE SECTION -->
  <!-- UPLOAD CSV -->
  <h1 *ngIf="!csvFilePage && !csvFilePageDownload && devicesToInsertPage" class="textM" style="text-align: center; height: 7%" mat-dialog-title>
    {{this.localiser.get("uploadCSV.reviewTitle")}}
  </h1>

  <!-- CONTENT SECTION -->
  <!-- HOME -->
  <div *ngIf="!csvFilePage && !csvFilePageDownload && !devicesToInsertPage" mat-dialog-content class="bodyForm"
       style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; align-items: center; justify-items: center;">

    <div (click)="toCsvFilePage()" class="csvButton marginAuto">
      <div style="height: 70%">
        <span class="material-icons-outlined textXXL csvButtonIcon centerVert">
          cloud_upload
        </span>
      </div>
      <div style="height: 30%" class="csvButtonIcon">
        <h3 class="textS+" style="color: #18264f">{{this.localiser.get("uploadCSV.msg")}}</h3>
      </div>
    </div>

    <div (click)="toCsvFilePageDownload()" class="csvButton marginAuto">
      <div style="height: 70%">
        <span class="material-icons-outlined textXXL csvButtonIcon centerVert">
          cloud_download
        </span>
      </div>
      <div style="height: 30%" class="csvButtonIcon">
        <h3 class="textS+" style="color: #18264f">{{this.localiser.get("downloadCSV.msg")}}</h3>
      </div>
    </div>


  </div>

  <!-- CONTENT SECTION -->
  <!-- UPLOAD CSV -->
  <div *ngIf="csvFilePage && !devicesToInsertPage" mat-dialog-content class="bodyForm">

    <div class="row rowSelectorCSVType">
      <div class="selectCSVTypeDiv">
        <div (click)="changeCsvToLuminaries(true)" class="selectCSVTypeLum" [ngClass]="{selectorActive: csvOfLuminaries}">
          <h4 class="textS+ centerVert">{{this.localiser.get("devices.luminaries")}}</h4>
        </div>
        <div (click)="changeCsvToLuminaries(false)" class="selectCSVTypeSens" [ngClass]="{selectorActive: !csvOfLuminaries}">
          <h4 class="textS+ centerVert">{{this.localiser.get("devices.sensors")}}</h4>
        </div>
      </div>
    </div>

    <!-- LUMINARIES -->
    <div *ngIf="csvOfLuminaries" style="height: 70%; display: contents">
      <div style="height: 10%; margin-top: 2%">
        <h3 class="textS+">{{this.localiser.get("uploadCSV.dataLums")}}:</h3>
      </div>
      <div>
        <table style="background-color: white; color: #18264f; width: 80%; margin: auto">
          <tr>
            <th class="separator">{{this.localiser.get("uploadCSV.lumMAC")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumName")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumProject")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumFloorplan")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumVersion")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumPower")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumSN")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumLed")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumLumen")}}</th>
          </tr>
          <tr>
            <td class="separator">{{this.localiser.get("uploadCSV.text")}}</td>
            <td class="separator">{{this.localiser.get("uploadCSV.text")}}</td>
            <td class="separator">{{this.localiser.get("uploadCSV.text")}}</td>
            <td class="separator">{{this.localiser.get("uploadCSV.text")}}</td>
            <td class="separator">{{this.localiser.get("uploadCSV.text")}}</td>
            <td class="separator">{{this.localiser.get("uploadCSV.number")}}</td>
            <td class="separator">{{this.localiser.get("uploadCSV.text")}}</td>
            <td class="separator">{{this.localiser.get("uploadCSV.text")}}</td>
            <td class="separator">{{this.localiser.get("uploadCSV.number")}}</td>
          </tr>
        </table>
      </div>
      <div class="row" style="height: 40%">
        <div class="col" style="text-align: center">
          <button class="customButtonColor textS centerVert" mat-button (click)="downloadTemplate(true)">
            {{this.localiser.get("uploadCSV.downloadTemplate")}}
          </button>
        </div>
        <div class="col" style="text-align: center">
          <label for="files" class="customButtonColor textS+ centerVert mat-button" style="width: 25%">
            <div class="row marginAuto">
              <span class="material-icons-outlined textXM csvButtonIcon marginAuto">
                cloud_upload
              </span>
            </div>
            <div class="row marginAuto">
              <h3 class="textXS" style="margin: auto auto 10% auto; color: #18264f">{{this.localiser.get("uploadCSV.msg")}}</h3>
            </div>
          </label>
          <input type="file" id="files" (change)="onSelectFile($event)" accept=".csv" hidden/>
          <h3 *ngIf="errorMessage != ''" class="errorMessage textS">{{errorMessage}}</h3>
        </div>
      </div>
    </div>

    <!-- SENSORS -->
    <div *ngIf="!csvOfLuminaries" style="height: 70%; display: contents">
      <div style="height: 10%; margin-top: 2%">
        <h3 class="textS+">{{this.localiser.get("uploadCSV.dataSens")}}:</h3>
      </div>
      <div>
        <table style="background-color: white; color: #18264f; width: 25%; margin: auto">
          <tr>
            <th class="separator">{{this.localiser.get("uploadCSV.lumMAC")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumName")}}</th>
          </tr>
          <tr>
            <td class="separator">{{this.localiser.get("uploadCSV.text")}}</td>
            <td class="separator">{{this.localiser.get("uploadCSV.text")}}</td>
          </tr>
        </table>
      </div>
      <div class="row" style="height: 40%">
        <div class="col" style="text-align: center">
          <button class="customButtonColor textS centerVert" mat-button (click)="downloadTemplate(false)">
            {{this.localiser.get("uploadCSV.downloadTemplate")}}
          </button>
        </div>
        <div class="col" style="text-align: center">
          <label for="filesSens" class="customButtonColor textS+ centerVert mat-button" style="width: 25%">
            <div class="row marginAuto">
              <span class="material-icons-outlined textXM csvButtonIcon marginAuto">
                cloud_upload
              </span>
            </div>
            <div class="row marginAuto">
              <h3 class="textXS" style="margin: auto auto 10% auto; color: #18264f">{{this.localiser.get("uploadCSV.msg")}}</h3>
            </div>
          </label>
          <input type="file" id="filesSens" (change)="onSelectFile($event)" accept=".csv" hidden/>
          <h3 *ngIf="errorMessage != ''" class="errorMessage textS">{{errorMessage}}</h3>
        </div>
      </div>
    </div>

  </div>

  <!-- UPLOAD CSV -->
  <div *ngIf="csvFilePageDownload && !devicesToInsertPage" mat-dialog-content class="bodyForm">

    <div class="row rowSelectorCSVType">
      <div class="selectCSVTypeDiv">
        <div (click)="changeCsvToLuminaries(true)" class="selectCSVTypeLum" [ngClass]="{selectorActive: csvOfLuminaries}">
          <h4 class="textS+ centerVert">{{this.localiser.get("devices.luminaries")}}</h4>
        </div>
        <div (click)="changeCsvToLuminaries(false)" class="selectCSVTypeSens" [ngClass]="{selectorActive: !csvOfLuminaries}">
          <h4 class="textS+ centerVert">{{this.localiser.get("devices.sensors")}}</h4>
        </div>
      </div>
    </div>
    
    <!-- LUMINARIES -->
    <div *ngIf="csvOfLuminaries" style="height: 70%; display: contents">
      <div class="row" style="height: 40%">
        <div class="col" style="text-align: center">
          <button (click)="downloadLuminariesCSV()" class="customButtonColor textS+ mat-button" style="width: 25%; margin-top: 10%">
            <div class="row marginAuto">
              <span class="material-icons-outlined textXM csvButtonIcon marginAuto">
                cloud_download
              </span>
            </div>
            <div class="row marginAuto">
              <h3 class="textS+" style="margin: auto auto 10% auto; color: #18264f">{{this.localiser.get("downloadCSV.msg")}}</h3>
            </div>
          </button>
        </div>
      </div>
    </div>

    <!-- SENSORS -->
    <div *ngIf="!csvOfLuminaries" style="height: 70%; display: contents">
      <div class="row" style="height: 40%">
        <div class="col" style="text-align: center">
          <button (click)="downloadSensorsCSV()" class="customButtonColor textS+ mat-button" style="width: 25%; margin-top: 10%">
            <div class="row marginAuto">
              <span class="material-icons-outlined textXM csvButtonIcon marginAuto">
                cloud_download
              </span>
            </div>
            <div class="row marginAuto">
              <h3 class="textS+" style="margin: auto auto 10% auto; color: #18264f">{{this.localiser.get("downloadCSV.msg")}}</h3>
            </div>
          </button>
        </div>
      </div>
    </div>

  </div>

  <!-- CONTENT SECTION -->
  <!-- REVIEW DEVICES -->
  <div *ngIf="!csvFilePage && devicesToInsertPage" mat-dialog-content class="bodyForm">

    <!-- LUMINARIES -->
    <div *ngIf="csvOfLuminaries" style="height: 70%; display: contents">
      <div style="height: 10%; margin-top: 2%">
        <h3 class="textS+">{{this.localiser.get("uploadCSV.reviewLums")}}:</h3>
      </div>
      <div>
        <div class="row" style="width: 26%; margin: auto auto 1%;">
          <div class="col" style="display: flex; margin-right: 10%;">
            <h3 class="textS" style="margin: auto 5% auto auto">{{this.localiser.get("uploadCSV.update")}}</h3>
            <span class="material-icons-outlined textS+ updateDeviceIcon verticalAlign">
              update
            </span>
          </div>
          <div class="col" style="display: flex">
            <h3 class="textS" style="margin: auto 5% auto auto">{{this.localiser.get("uploadCSV.new")}}</h3>
            <span class="material-icons-outlined textS+ newDeviceIcon verticalAlign" style="margin: 0">
              warning
            </span>
          </div>
        </div>
        <table style="background-color: white; color: #18264f; width: 80%; margin: auto">
          <tr>
            <th class="separator">{{this.localiser.get("uploadCSV.lumMAC")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumName")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumProject")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumFloorplan")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumVersion")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumPower")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumSN")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumLed")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumLumen")}}</th>
            <th></th>
          </tr>
          <tr *ngFor="let lum of devicesToInsert">
            <td class="separator">{{lum.mac}}</td>
            <td class="separator">{{lum.name}}</td>
            <td class="separator">{{getProject(lum.project)}}</td>
            <td class="separator">{{getFloorplan(lum.floorplan)}}</td>
            <td class="separator">{{lum.version}}</td>
            <td class="separator">{{lum.power}}</td>
            <td class="separator">{{lum.sn}}</td>
            <td class="separator">{{lum.led}}</td>
            <td class="separator">{{lum.lumen}}</td>
            <td>
              <span *ngIf="lumAlreadyRegistered(lum.mac)" class="material-icons-outlined textS+ updateDeviceIcon verticalAlign">
                update
              </span>
              <span *ngIf="!lumAlreadyRegistered(lum.mac)" class="material-icons-outlined textS+ newDeviceIcon verticalAlign">
                warning
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <!-- SENSORS -->
    <div *ngIf="!csvOfLuminaries" style="height: 70%; display: contents">
      <div style="height: 10%; margin-top: 2%">
        <h3 class="textS+">{{this.localiser.get("uploadCSV.reviewSens")}}:</h3>
      </div>
      <div>
        <div class="row" style="width: 26%; margin: auto auto 1%;">
          <div class="col" style="display: flex; margin-right: 10%;">
            <h3 class="textS" style="margin: auto 5% auto auto">{{this.localiser.get("uploadCSV.update")}}</h3>
            <span class="material-icons-outlined textS+ updateDeviceIcon verticalAlign">
              update
            </span>
          </div>
          <div class="col" style="display: flex">
            <h3 class="textS" style="margin: auto 5% auto auto">{{this.localiser.get("uploadCSV.new")}}</h3>
            <span class="material-icons-outlined textS+ newDeviceIcon verticalAlign" style="margin: 0">
              warning
            </span>
          </div>
        </div>
        <table style="background-color: white; color: #18264f; width: 25%; margin: auto">
          <tr>
            <th class="separator">{{this.localiser.get("uploadCSV.lumMAC")}}</th>
            <th class="separator">{{this.localiser.get("uploadCSV.lumName")}}</th>
            <th></th>
          </tr>
          <tr *ngFor="let sens of devicesToInsert">
            <td class="separator">{{sens.mac}}</td>
            <td class="separator">{{sens.name}}</td>
            <td>
              <span *ngIf="sensorAlreadyRegistered(sens.mac)" class="material-icons-outlined textS+ updateDeviceIcon verticalAlign">
                update
              </span>
              <span *ngIf="!sensorAlreadyRegistered(sens.mac)" class="material-icons-outlined textS+ newDeviceIcon verticalAlign">
                warning
              </span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  <!-- BOTTOM BUTTONS SECTION -->
  <!-- HOME OPTIONS -->
  <div *ngIf="!csvFilePage && !devicesToInsertPage" mat-dialog-actions>
    <div class="col" style="text-align: center; margin-top: 2%">
      <button class="customButtonColor textS+" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
    </div>
  </div>

  <!-- BOTTOM BUTTONS SECTION -->
  <!-- UPLOAD CSV PAGE -->
  <div *ngIf="csvFilePage && !devicesToInsertPage" mat-dialog-actions class="bottomActions">
    <div class="col" style="text-align: center; margin-top: 2%">
      <button class="customButtonColor textS+" mat-button (click)="toBackHome()">{{this.localiser.get("button.back")}}</button>
    </div>
    <div class="col" style="text-align: center; margin-top: 2%">
      <button class="customButtonColor textS+" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
    </div>
  </div>

  <!-- BOTTOM BUTTONS SECTION -->
  <!-- REVIEW DEVICES PAGE -->
  <div *ngIf="!csvFilePage && devicesToInsertPage" mat-dialog-actions class="bottomActions">
    <div class="col" style="text-align: center; margin-top: 2%">
      <button class="customButtonColor textS+" mat-button (click)="toCsvFilePage()">{{this.localiser.get("button.back")}}</button>
    </div>
    <div class="col" style="text-align: center; margin-top: 2%">
      <button class="customButtonColorDone textS+" mat-button (click)="sendToInsert()">{{this.localiser.get("button.update")}}</button>
      <div style="margin-top: 1vh">
        <mat-progress-spinner *ngIf="updating" style="margin: auto;" mode="indeterminate" diameter="30"></mat-progress-spinner>
      </div>
    </div>
  </div>

</div>
